export default "__VITE_ASSET__BBnyTRe4__"